import React from "react";
import { PublicPageShell } from "@/components/landing/PublicPageShell";
import { ResumeAtsWidget } from "@/components/landing/ResumeAtsWidget";
import { FileSearch2 } from "lucide-react";

export default function ResumeCheckerPage() {
  return (
    <PublicPageShell>
      <div className="max-w-5xl mx-auto px-6 py-20" data-testid="resume-checker-page">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-400 flex items-center gap-2"><FileSearch2 className="w-3.5 h-3.5" /> Free AI Tool</span>
            <h1 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight mt-3">Check Your Resume's ATS Score — In 10 Seconds</h1>
            <p className="text-slate-400 mt-4 max-w-md">Drop your resume in and our AI scores it exactly like a real Applicant Tracking System scans it — keyword match, formatting, section structure — no signup needed to see your score.</p>
          </div>
          <ResumeAtsWidget />
        </div>
      </div>
    </PublicPageShell>
  );
}
